/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListOrganizationsResponseMeta
 */
export interface ListOrganizationsResponseMeta {
    /**
     * 
     * @type {number}
     * @memberof ListOrganizationsResponseMeta
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof ListOrganizationsResponseMeta
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof ListOrganizationsResponseMeta
     */
    total?: number | null;
}

/**
 * Check if a given object implements the ListOrganizationsResponseMeta interface.
 */
export function instanceOfListOrganizationsResponseMeta(value: object): value is ListOrganizationsResponseMeta {
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function ListOrganizationsResponseMetaFromJSON(json: any): ListOrganizationsResponseMeta {
    return ListOrganizationsResponseMetaFromJSONTyped(json, false);
}

export function ListOrganizationsResponseMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOrganizationsResponseMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'limit': json['limit'],
        'offset': json['offset'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function ListOrganizationsResponseMetaToJSON(json: any): ListOrganizationsResponseMeta {
    return ListOrganizationsResponseMetaToJSONTyped(json, false);
}

export function ListOrganizationsResponseMetaToJSONTyped(value?: ListOrganizationsResponseMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limit': value['limit'],
        'offset': value['offset'],
        'total': value['total'],
    };
}

